<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  RARE_EARTHS,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_RARE_EARTHS,
  SUBSCRIPTION_ESG_RARE_EARTHS,
  SUBSCRIPTION_FORECASTS_RARE_EARTHS,
} from '~/constants/services/constants'
import rareEarthsData from '~/constants/data-reports/rare-earths'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(RARE_EARTHS)
const productData = ref(rareEarthsData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_RARE_EARTHS)
const esgSubscription = ref(SUBSCRIPTION_ESG_RARE_EARTHS)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_RARE_EARTHS)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${RARE_EARTHS.name} Data and Reports`,
})
useHead(seo)
</script>
